import React, { useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import CommentForm from "./CommentForm"
import dayjs from 'dayjs'
import calendar from 'dayjs/plugin/calendar'
import Ratings from 'react-ratings-declarative'

import * as commentStyles from './comment.module.scss'

const CommentBox = styled.article`
  border: 2px solid #ddd;
  margin: 2.5rem 0 0 ${props => (props.children ? "2rem" : "0")};
  padding: 3.5rem;
`

dayjs.extend(calendar)

const SingleComment = ({ comment }) => (
  <div>
    <div className={commentStyles.rating}>
       {!!comment.rating === true ? 
        <Ratings
        rating={comment.rating}
        widgetDimensions="20px"
        widgetSpacings="5px"
        widgetRatedColors="rgb(255,102,0)"
      >
        <Ratings.Widget  />
        <Ratings.Widget />
        <Ratings.Widget  />
        <Ratings.Widget  />
        <Ratings.Widget />
      </Ratings> :
      <div></div>  
    } 
     
        
      </div>
    <div className={commentStyles.flexContainer}>
    
      
      <div className={commentStyles.flex}>
        <p className={commentStyles.commentAuthor}>
          {comment.name} <span>says</span>
        </p>
        <p className={commentStyles.commentTime}>
          {comment.time && (<time>{
          dayjs(comment.time.toDate()).calendar()}</time>)}
        </p>
      </div>
    </div>
    <p className={commentStyles.commentContent}>{comment.content}</p>
  </div>
)

const Comment = ({ comment, children, blogId, path }) => {
  const [showReplyBox, setShowReplyBox] = useState(false)
  return (
    <CommentBox >
      <SingleComment comment={comment} />
      {children && (
        children.sort((a, b) => {
          return a.time - b.time
        }).map((child) => {
          return (<CommentBox child className="comment-reply" key={child.id}>
            <SingleComment comment={child} /> 
          </CommentBox>)
        })
        
      )}
      
        <div>
          {showReplyBox ? (
            <div>
              <button
                className={`btn btn-color ${commentStyles.replyBtn} ${commentStyles.cancelBtn}`}
                onClick={() => setShowReplyBox(false)}
              >
                Cancel Reply
              </button>
              <CommentForm parentId={comment.id} blogId={blogId} path={path} />
            </div>
          ) : (
            <button className={`btn btn-color ${commentStyles.replyBtn}`} onClick={() => setShowReplyBox(true)}>
              Reply
            </button>
          )}
        </div>
      
    </CommentBox>
  )
}

Comment.propTypes = {
  comment: PropTypes.object.isRequired,
  blogId: PropTypes.string,
  children: PropTypes.array
}

export default Comment